import * as React from 'react';
import type { TestimoniesSectionBlockViewModel } from '../ViewModel/TestimoniesSectionBlockViewModel.csharp';
import type { GobiStoryProps } from '~/Features/StudyPage/Campus/Components/GobiStory/GobiStory';
import { TestimoniesSection } from '~/Features/StudyPage/Campus/Sections/TestimoniesSection/TestimoniesSection';

export const TestimoniesSectionBlock: React.FC<TestimoniesSectionBlockViewModel> = props => {
    const { id, heading, testimonies, gobiStoryId, imageFallback, translations, variant } = props;

    const getGobiProps = (): GobiStoryProps | undefined =>
        gobiStoryId
            ? {
                  storyId: gobiStoryId,
                  openLabel: translations.openPlayer,
                  errorMessage: translations.failedToLoadVideo,
              }
            : undefined;

    return (
        <TestimoniesSection
            id={id}
            heading={heading}
            gobiStory={getGobiProps()}
            testimonies={testimonies}
            imageFallback={imageFallback}
            variant={variant}
        />
    );
};
